import { BaseModel } from "sjs-base-model";
import CercaSimulazioneTabellaModel from "./CercaSimulazioneTabellaModel";

export default class CercaSimulazioneFormModel extends BaseModel {
    public readonly denominazione: string = "";
    public readonly numSimulazione: string = "";
    public readonly agente: string = "";
    public readonly canale: string = "";
    public readonly segmento: string = "";
    public readonly tipoRichiesta: string = "";
    public readonly atc: string = "";
    public readonly tipoCliente: string = "";
    public readonly rata: string = "";
    public readonly durata: string = "";
    public readonly importo: string = "";
    public readonly dataCreazioneDa: string = "";
    public readonly dataCreazioneA: string = "";
    public readonly tipoProdotto: string = "";
    public readonly colName?: keyof CercaSimulazioneTabellaModel = "id";
    public readonly direction?: undefined | "A" | "D" = undefined;
    constructor(data: Partial<CercaSimulazioneFormModel>) {
        super();

        this.update(data);
    }
}
